module.exports = __webpack_public_path__ + "static/media/bekiLogo.943eb9a2.png";